import { Outlet } from "react-router-dom";

import { LessonContextProvider } from "@/contexts/useLesson";

const LessonLayout = () => {
  return (
    <LessonContextProvider>
      <Outlet />
    </LessonContextProvider>
  );
};

export default LessonLayout;
